export const ORGANISATION_ROLES = {
  ORGANISATION_ADMIN: "organisation_admin",
  USER: "user",
};

/** @deprecated Use ORGANISATION_ROLES */
export const COMPANY_ROLES = {
  ...ORGANISATION_ROLES,
  COMPANY_ADMIN: ORGANISATION_ROLES.ORGANISATION_ADMIN,
};

export const CUSTOMER_ROLES = {
  CUSTOMER_ADMIN: "customer_admin",
  USER: "user",
};

const LEGACY_ORG_ADMIN = "company_admin";

export function isSuperAdmin(user) {
  if (!user) return false;
  return user.isSuperAdmin === true || user.globalRole === "super_admin";
}

export function isOrganisationAdminRole(role) {
  return role === ORGANISATION_ROLES.ORGANISATION_ADMIN || role === LEGACY_ORG_ADMIN;
}

export function isCustomerAdmin(user) {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return user.customerRole === CUSTOMER_ROLES.CUSTOMER_ADMIN;
}

export function isOrganisationAdmin(user) {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  if (isCustomerAdmin(user)) return true;
  const role = user.organisationRole || user.companyRole;
  return isOrganisationAdminRole(role);
}

/** Organisation admins, customer admins, and super admins can manage users. */
export function canManageOrganisationUsers(user) {
  return isOrganisationAdmin(user);
}

/** @deprecated Use canManageOrganisationUsers */
export function canManageCompanyUsers(user) {
  return canManageOrganisationUsers(user);
}

export function canAccessAdminMenu(user) {
  if (!user) return false;
  return (
    isSuperAdmin(user) ||
    isCustomerAdmin(user) ||
    isOrganisationAdminRole(user.organisationRole || user.companyRole)
  );
}

export function formatOrganisationRole(role) {
  if (isOrganisationAdminRole(role)) return "Department Admin";
  return "User";
}

/** @deprecated Use formatOrganisationRole */
export function formatCompanyRole(role) {
  return formatOrganisationRole(role);
}
